import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import './media.css'
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { store } from './Components/store';
import { AuthProvider } from './Components/hooks/IsAuth';
import { GoogleOAuthProvider } from '@react-oauth/google';

const REACT_APP_CLIENT_ID = '1039078685850-kebls0510g8liih2j6g1o7ea5btjgce1.apps.googleusercontent.com'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId={REACT_APP_CLIENT_ID}>
  <Provider store={store}>
    <AuthProvider>
      <ToastContainer />
      <App />
    </AuthProvider>
  </Provider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
